/* eslint "import/no-mutable-exports": "off" */
const commonTypes = [
  {
    type: 'FULL_TIME', title: 'work_status.full_time', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'FIXED_TERM', title: 'work_status.fixed_term', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'PART_TIME', title: 'work_status.part_time', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'ENTREPRENEUR', title: 'work_status.entrepreneur', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'DISABILITY_RETIRED',
    title: 'work_status.disability_retired',
    isDetailsNeeded: false,
    intl: true,
  },
  {
    type: 'RETIRED', title: 'work_status.retired', isDetailsNeeded: false, intl: true,
  },
  {
    type: 'STUDENT', title: 'work_status.student', isDetailsNeeded: false, intl: true,
  },
  {
    type: 'UNEMPLOYED', title: 'work_status.unemployed', isDetailsNeeded: false, intl: true,
  },
  {
    type: 'OTHER', title: 'work_status.other', isDetailsNeeded: false, intl: true,
  },
];

const fiTypes = [
  {
    type: 'FULL_TIME', title: 'work_status.full_time', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'FIXED_TERM', title: 'work_status.fixed_term', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'PART_TIME', title: 'work_status.part_time', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'ENTREPRENEUR', title: 'work_status.entrepreneur', isDetailsNeeded: true, intl: true,
  },
  {
    type: 'DISABILITY_RETIRED',
    title: 'work_status.disability_retired',
    isDetailsNeeded: false,
    intl: true,
  },
  {
    type: 'RETIRED', title: 'work_status.retired', isDetailsNeeded: false, intl: true,
  },
  {
    type: 'STUDENT', title: 'work_status.student', isDetailsNeeded: false, intl: true,
  },
  {
    type: 'UNEMPLOYED', title: 'work_status.unemployed', isDetailsNeeded: false, intl: true,
  },
];

const mxTypes = [
  {
    type: 'FULL_TIME', title: 'work_status.full_time', isCompanyNeeded: true, isActivityTypeNeeded: false, isEmploymentDurationNeeded: true, intl: true,
  },
  {
    type: 'FIXED_TERM', title: 'work_status.fixed_term', isCompanyNeeded: true, isActivityTypeNeeded: false, intl: true,
  },
  {
    type: 'ENTREPRENEUR', title: 'work_status.entrepreneur', isCompanyNeeded: true, isActivityTypeNeeded: true, intl: true,
  },
  {
    type: 'RETIRED', title: 'work_status.retired', isCompanyNeeded: false, isActivityTypeNeeded: false, isRetirementTypeNeeded: true, intl: true,
  },
  {
    type: 'STUDENT', title: 'work_status.student', isCompanyNeeded: false, isActivityTypeNeeded: false, isUniversityNeeded: true, intl: true,
  },
  {
    type: 'UNEMPLOYED', title: 'work_status.unemployed', isCompanyNeeded: false, isActivityTypeNeeded: false, intl: true,
  },
  {
    type: 'FREELANCER', title: 'work_status.freelancer', isFreelancersIndustryNeeded: true, intl: true,
  },
  {
    type: 'HOUSE_WIFE', title: 'work_status.house_wife', isCompanyNeeded: false, isActivityTypeNeeded: false, intl: true,
  },
];

const esTypes = [
  {
    type: 'FULL_TIME', title: 'work_status.full_time', isActivityTypeNeeded: true, isIndustryNeeded: true, isEmploymentDurationNeeded: true, intl: true,
  },
  {
    type: 'FIXED_TERM', title: 'work_status.fixed_term', isActivityTypeNeeded: true, isIndustryNeeded: true, isEmploymentDurationNeeded: true, intl: true,
  },
  {
    type: 'ENTREPRENEUR', title: 'work_status.entrepreneur', isActivityTypeNeeded: true, isIndustryNeeded: true, intl: true,
  },
  {
    type: 'RETIRED', title: 'work_status.retired', fixedIndustryValue: 'RETIRED', fixedActivityTypeValue: 'RETIRED', intl: true,
  },
  {
    type: 'STUDENT', title: 'work_status.student', fixedIndustryValue: 'STUDENT', fixedActivityTypeValue: 'STUDENT', intl: true,
  },
  {
    type: 'UNEMPLOYED', title: 'work_status.unemployed', fixedIndustryValue: 'UNEMPLOYED', fixedActivityTypeValue: 'UNEMPLOYED', intl: true,
  },
  {
    type: 'HOUSE_WIFE', title: 'work_status.house_wife', fixedIndustryValue: 'HOUSE_WIFE', fixedActivityTypeValue: 'HOUSE_WIFE', intl: true,
  },
  { type: 'OTHER', title: 'work_status.other', intl: true },
];

const plTypes = [
  {
    type: 'FULL_TIME',
    title: 'work_status.full_time',
    isCompanyNeeded: true,
    isEmploymentDurationNeeded: true,
    intl: true,
  },
  {
    type: 'FIXED_TERM',
    title: 'work_status.fixed_term',
    isCompanyNeeded: true,
    isEmploymentDurationNeeded: true,
    isEmploymentTerminationNeeded: true,
    employmentTerminationCaptionKey: 'benefits_termination.title',
    intl: true,
  },
  {
    type: 'CIVIL_AGREEMENT',
    title: 'work_status.civil_agreement',
    isCompanyNeeded: true,
    isEmploymentDurationNeeded: true,
    intl: true,
  },
  {
    type: 'SELF_EMPLOYED',
    title: 'work_status.self_employed',
    isCompanyNeeded: true,
    isEmploymentDurationNeeded: true,
    intl: true,
  },
  {
    type: 'DISABILITY_RETIRED',
    title: 'work_status.disability_retired',
    isEmploymentDurationNeeded: true,
    isEmploymentTerminationNeeded: true,
    employmentTerminationCaptionKey: 'benefits_termination.title',
    intl: true,
  },
  {
    type: 'RETIRED',
    title: 'work_status.retired',
    isEmploymentDurationNeeded: true,
    intl: true,
  },
  {
    type: 'UNEMPLOYED',
    title: 'work_status.unemployed',
    intl: true,
  },
  {
    type: 'STUDENT',
    title: 'work_status.student',
    intl: true,
  },
  {
    type: 'CONTRACT',
    title: 'work_status.contract',
    isCompanyNeeded: true,
    isEmploymentDurationNeeded: true,
    isEmploymentTerminationNeeded: true,
    intl: true,
  },
];

const auTypes = [
  {
    type: 'FULL_TIME',
    title: 'work_status.full_time',
    areDetailsNeeded: true,
    intl: true,
  },
  {
    type: 'PART_TIME',
    title: 'work_status.part_time',
    areDetailsNeeded: true,
    intl: true,
  },
  {
    type: 'SELF_EMPLOYED',
    title: 'work_status.self_employed',
    areDetailsNeeded: true,
    intl: true,
  },
  {
    type: 'UNEMPLOYED',
    title: 'work_status.unemployed',
    intl: true,
  },
  {
    type: 'STUDENT',
    title: 'work_status.student',
    intl: true,
  },
  {
    type: 'STAY_HOME_PARENT',
    title: 'work_status.stay_home_parent',
    intl: true,
  },
  {
    type: 'RETIRED',
    title: 'work_status.retired',
    intl: true,
  },
];

const ltTypes = [
  { type: 'FULL_TIME', title: 'work_status.full_time', intl: true },
  { type: 'FIXED_TERM', title: 'work_status.fixed_term', intl: true },
  { type: 'PART_TIME', title: 'work_status.part_time', intl: true },
  { type: 'ENTREPRENEUR', title: 'work_status.entrepreneur', intl: true },
  { type: 'GOVERNMENT', title: 'work_status.government', intl: true },
  { type: 'RETIRED', title: 'work_status.retired', intl: true },
  { type: 'DISABILITY_RETIRED', title: 'work_status.disability_retired', intl: true },
  { type: 'STUDENT', title: 'work_status.student', intl: true },
  { type: 'UNEMPLOYED', title: 'work_status.unemployed', intl: true },
  { type: 'OTHER', title: 'work_status.other', intl: true },
];

const eeTypes = [
  {
    type: 'FULL_TIME', title: 'work_status.full_time', isDetailsNeeded: true, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'FIXED_TERM', title: 'work_status.fixed_term', isDetailsNeeded: true, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'PART_TIME', title: 'work_status.part_time', isDetailsNeeded: true, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'ENTREPRENEUR', title: 'work_status.entrepreneur', isDetailsNeeded: true, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'DISABILITY_RETIRED', title: 'work_status.disability_retired', isDetailsNeeded: false, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'RETIRED', title: 'work_status.retired', isDetailsNeeded: false, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'STUDENT', title: 'work_status.student', isDetailsNeeded: false, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'UNEMPLOYED', title: 'work_status.unemployed', isDetailsNeeded: false, occupationSectorNeeded: true, intl: true,
  },
  {
    type: 'MATERNITY', title: 'ocupation.maternity', isDetailsNeeded: false, occupationSectorNeeded: false, intl: true,
  },
  {
    type: 'OTHER', title: 'work_status.other', isDetailsNeeded: false, occupationSectorNeeded: true, intl: true,
  },
];

let data = [];

switch (COUNTRY) {
  case 'FI':
    data = data.concat(fiTypes);
    break;
  case 'MX':
    data = data.concat(mxTypes);
    break;
  case 'ES':
    data = data.concat(esTypes);
    break;
  case 'PL':
    data = data.concat(plTypes);
    break;
  case 'AU':
    data = data.concat(auTypes);
    break;
  case 'LT':
    data = data.concat(ltTypes);
    break;
  case 'EE':
    data = data.concat(eeTypes);
    break;
  default:
    data = data.concat(commonTypes);
}

export default data;
